"use client";

import React from "react";
import styles from "./Accreditation.module.scss";
import cn from "clsx";
import UnivoImage from "@/components/common/UnivoImage";
import UnivoCarousel from "@/components/common/UnivoCarousel";
import { imageCdn } from "@/constants/images";

const data = [
  {
    logo: imageCdn("_s/QS_Ranked_Online_MBA_fc05244ed7.webp"),
    title: "QS Ranked Online MBA 2024",
    desc: "India’s only Online MBA ranked by QS among the Asia Pacific Top 10.",
  },
  {
    logo: imageCdn("_s/WASC_new_logo_1_d7a81ca9c3.webp"),
    title: "WASC Accreditation (USA)",
    desc: "Accredited by the Western Association of Schools and Colleges (WASC), a globally respected recognition of academic quality..",
  },
  {
    logo: imageCdn("_s/Times_Higher_Education_Employability_Rankings_2412d3031f.webp"),
    title: "Times Higher Education",
    desc: "Ranked by Times Higher Education for strong graduate employability and employer reputation.",
  },
  {
    logo: imageCdn("_s/QAA_UK_Accreditation_0e7a3db0e9.webp"),
    title: "QAA (UK) Accreditation",
    desc: "Accredited by the UK’s Quality Assurance Agency (QAA), reflecting internationally benchmarked academic standards.",
  },
  {
    logo: imageCdn("_s/WES_Recognition_db67cedfc4.webp"),
    title: "WES Recognition",
    desc: "Recognized by World Education Services (WES) for degree evaluation in Canada and the USA.",
  },
  {
    logo: imageCdn("_s/Times_Higher_Education_Employability_Rankings_1_15a2c801ea.webp"),
    title: "NIRF 22nd rank",
    desc: "Ranked among India’s top universities by the National Institutional Ranking Framework",
  },
];

interface AccreditationProps {
  isProgramListPage?: boolean;
}

const Accreditation: React.FC<AccreditationProps> = ({
  isProgramListPage = false,
}) => {
  return (
    <section className={styles.container}>
      <h2
        className={styles.mainTitle}
      >{`${!isProgramListPage ? "Globally" : ""} Accredited. Trusted. Future-Ready.`}</h2>
      <hr className={styles.divider} />

      <UnivoCarousel
        preset="accreditation"
        className={styles.carousel}
        settings={{
          navigation: {
            status: false,
            nextEl: styles.nextBtn,
            prevEl: styles.prevBtn,
          }
        }}
      >
        {data.map((item, index) => (
          <div key={index} className={styles.card}>
            <div className={styles.imageBox}>
              <UnivoImage
                src={item.logo}
                alt={item.title}
                width={110}
                height={80}
                sizes="120px"
                loading="lazy"
                fetchPriority="low"
              />
            </div>
            <h3 className={cn(styles.cardTitle, "lining-nums")}>
              {item.title}
            </h3>
            <p className={cn(styles.cardDescription, "lining-nums")}>
              {item.desc}
            </p>
          </div>
        ))}
      </UnivoCarousel>
    </section>
  );
};

export default Accreditation;
